{
    "l_first_name": "First name",
    "l_last_name": "Last name",
    "l_sex": "Gender",
    "l_year_born": "Year of birth",
    "l_occupation": "Occupation",
    "l_no_results": "No results found",
    "l_condition_include": "includes",
    "l_search_settings": "Search settings",
    "l_male": "male",
    "l_female": "female",
    "l_academic_title": "Academic title",
    "l_confession": "Religion",
    "l_dienstgrad": "Military rank",
    "l_deceived": "Deceased",
    "l_wohnorte": "Places of residence",
    "l_buergerorte": "Citizenship places",
    "l_directories": "Directories",
    "l_remarks": "Remarks",
    "l_sources": "Sources",
    "l_parties": "Parties",
    "l_einsitze": "Seats",
    "l_conncetions": "Connections",
    "l_picture": "Picture",
    "l_functions": "Functions",
    "l_function": "Function",
    "l_dict_dnb": "German National Library Catalog",
    "l_dict_hls": "Historical Lexicon of Switzerland (HLS)",
    "l_time_join": "Date of joining",
    "l_time_exit": "Date of leaving",
    "l_wahlkreis": "Electoral district",
    "l_wahlkreise": "Electoral districts",
    "l_from": "from",
    "l_until": "until",
    "l_since": "since",
    "l_fraktion": "Parliamentary group",
    "l_fraktionen": "Parliamentary groups",
    "l_all": "all",
    "l_born_before": "Born before",
    "l_born_after": "Born after",
    "l_party_membership": "Party membership",
    "l_short_name": "Short name",
    "l_mandates": "Mandates",
    "l_political_activities": "Political activities",
    "l_email": "Email",
    "l_email_private": "Private email",
    "l_mobile": "Mobile",
    "l_mobile_private": "Private mobile",
    "l_telephone": "Telephone",
    "l_telephone_private": "Private telephone",
    "l_address": "Address",
    "l_anrede": "Salutation",
    "l_party": "Party",
    "l_zip_code": "Zip code",
    "l_spouse": "Spouse",
    "l_zivilstand": "Marital status",
    "l_search": "search",
    "l_reset": "reset",
    "l_männlich": "male",
    "l_weiblich": "female",
    "l_gremium": "Committee",
    "l_title": "Title",
    "l_type": "Type",
    "l_date": "Date",
    "l_time": "Time",
    "l_traktanden": "Agenda items",
    "l_number_short": "No.",
    "l_documents": "Documents",
    "l_video": "Video",
    "l_members": "Members",
    "l_additional_infos": "Additional information",
    "l_kommission": "Commission",
    "l_kommissionen": "Commissions",
    "l_sitzungen": "Sessions",
    "l_contact_data": "Contact data",
    "h1_fraktionen": "Parliamentary Groups",
    "h1_kommissionen": "Commissions",
    "h1_mitglieder": "Members",
    "h1_sitzungen": "Sessions of the Cantonal Council and Commissions",
    "h1_wahlkreise": "Electoral Districts of the Canton of Zurich",
    "h1_personen": "Members of the Zurich Cantonal Council since 1803",
    "h1_kantonsrat": "Cantonal Council",
    "st_search_persons": "Person Search",
    "l_data": "Data",
    "l_ort": "Place",
    "l_geschaefts_art": "Type of business",
    "h1_geschaefte": "Business",
    "l_pendent_bei": "Pending with",
    "l_beginn": "Beginning",
    "l_role": "Role",
    "l_participation": "Participation",
    "l_direktion": "Directorate",
    "l_politische_gemeinde": "Political municipality",
    "l_ablauf": "Process",
    "l_status": "Status",
    "l_frist": "Deadline",
    "l_sitzungs_datum": "Meeting date",
    "l_geschaefte": "Business"
}